import { useState } from "react";
import axios from "axios";

import styles from "./Home.module.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { siteIP } from "../../util/backendUtilities";

import { ThreeDots } from "react-loading-icons";

export default function StayConnected() {
  const [email, setEmail] = useState();
  const [message, setMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = () => {
    setIsLoading(true);
    axios
      .post(`${siteIP}/addSubscriber`, { emailAddress: email })
      .then((res) => {
        setMessage(res.data.message);
        setIsLoading(false);
      });
  };

  return (
    <div className={styles.stayConnectedContainer}>
      <h1 className={styles.stayConnectedTitle}>Stay Connected</h1>

      <p className={styles.stayConnectedDescription}>
        Subscribe to our newsletter to receive updates on our programs, success
        stories, and ways you can make a difference in the lives of
        Mississippi's roadworkers.
      </p>

      <div className={styles.emailForm}>
        <input
          type="email"
          placeholder="Enter you email address"
          className={styles.emailInput}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className={styles.subscribeButton} onClick={handleSubscribe}>
          <span className={styles.subscribeText}>Subscribe</span>
          {isLoading ? <ThreeDots width="15%" /> : <IoIosArrowRoundForward />}
        </button>
      </div>
      <p>{message}</p>

      <p className={styles.privacyNotice}>
        We respect your privacy and will never share your email address
      </p>
    </div>
  );
}
